export default {"src":"/_next/static/media/logo.07629d48.svg","height":53,"width":116,"blurWidth":0,"blurHeight":0};